import React, { useEffect } from 'react';
import { clsx } from 'clsx';
import { useTranslation } from 'react-i18next';
import { useItem, useItemReleasePayment } from '@/hooks/item';
import { ItemReleasePaymentModal } from '@/types/modal';
import { ErrorModal, LoadingBodyModal, StandardModal, SuccessModal } from '@/components/molecules/common/Modal';
import styles from './Modal.module.scss';

const View: React.FC<{ modal: ItemReleasePaymentModal }> = ({ modal }) => {
  const { t } = useTranslation();
  const { item, onClose } = modal;

  const itemR = useItem(item.productId, false);
  const submitR = useItemReleasePayment(item.productId);

  useEffect(() => {
    if (submitR.kind === 'Completed') {
      itemR.refetch();
    }
  }, [submitR.kind]);

  if (submitR.kind === 'Error') {
    return (
      <ErrorModal
        title={t('modal.item_release_payment.title')}
        error={submitR.error}
        onClose={onClose}
      />
    );
  } else if (submitR.kind === 'Completed') {
    return (
      <SuccessModal
        title={t('modal.item_release_payment.title')}
        onClose={onClose}
      />
    );
  }

  const body =
    submitR.kind === 'Loading' ? (
      <LoadingBodyModal height={40} />
    ) : (
      <div className={clsx([styles.text1rem, styles.paddingY1rem])}>
        <div dangerouslySetInnerHTML={{ __html: t('modal.item_release_payment.body', item) }} />
      </div>
    );

  return (
    <StandardModal
      title={t('modal.item_release_payment.title')}
      onClose={onClose}
      onSubmit={submitR.mutate}
      closeLabel={t('common.no').toUpperCase()}
      submitLabel={t('common.yes').toUpperCase()}
      submittable={submitR.kind !== 'Loading'}
      body={body}
      containerStyle={{ width: 500 }}
      modalName="item_release_payment"
    />
  );
};

export default View;
